import dayjs from "dayjs";
import utc from "dayjs/plugin/utc.js";
import timezone from "dayjs/plugin/timezone.js";

dayjs.extend(utc);
dayjs.extend(timezone);

// 將 timestamp 轉換為指定時區的時間字串
export const convertTimeStamp = (
  dateTime,
  formatString = "YYYY-MM-DD HH:mm",
  tz = "Asia/Taipei"
) => {
  const _dateTime = dayjs.unix(dateTime);
  return _dateTime.tz(tz).format(formatString);
};

export const convertTimestampToDate = (timestamp) => {
  return dayjs.unix(timestamp).format("YYYY-MM-DD HH:mm");
};

// 將日期時間按照指定時區轉換為 UTC timestamp
export const convertToUTCTimestamp = (dateTime, timezone = "Asia/Taipei") => {
  if (!dateTime) return null;
  return dayjs.tz(dateTime, timezone).utc().unix();
};
